<template>
	<router-view />
</template>

<script>
	export default {
		name: 'Index',

		data() {
			return {}
		},
	}
</script>

<style lang="css" scoped></style>
